import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-2 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " (HCFA-1500 Form Locators 10A - 10D) Patient's condition related to:")
  ])
], -1 /* HOISTED */)
const _hoisted_5 = { class: "form-check ms-2 pb-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "hcfa-patient-employment"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Employment")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-check ms-2 pb-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "hcfa-patient-auto"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Auto Accident")
], -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "row ms-3"
}
const _hoisted_10 = { class: "form-group col-12 col-lg-5 pe-lg-12 bg-white p-3 m-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "hcfa-auto-accident-state" }, " Select State", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-check ms-2 pb-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "hcfa-patient-other"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Other Accident")
], -1 /* HOISTED */)
const _hoisted_16 = { class: "px-4 w-100 mt-1" }
const _hoisted_17 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_claim_code",
  for: "referral-claim-code"
}, " Claim Code: ", -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " (HCFA-1500 Form Locator 16) Dates Patient Unable to Work in Current Occupation:")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_20 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "patient-unable-from" }, " Patient Unable to Work From: ", -1 /* HOISTED */)
const _hoisted_22 = { class: "input-group date datepickerInput" }
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_25 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "patient-unable-to" }, " Patient Unable to Work To: ", -1 /* HOISTED */)
const _hoisted_27 = { class: "input-group date datepickerInput" }
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " (HCFA-1500 Form Locator 18) Hospital Dates Related to Current Services:")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "hospitalization-start-date" }, " Hospitalization Start Date: ", -1 /* HOISTED */)
const _hoisted_33 = { class: "input-group date datepickerInput" }
const _hoisted_34 = ["value"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_36 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "hospitalization-end-date" }, " Hospitalization End Date: ", -1 /* HOISTED */)
const _hoisted_38 = { class: "input-group date datepickerInput" }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_41 = { class: "form-check custom-checkbox ms-2 pb-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-2",
  for: "hcfa-emergency-treatment"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "(HCFA-1500 Form Locator 24C) Emergency Treatment Indicator ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Additional Billing Information",
    type: "his-section",
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                id: "hcfa-patient-employment",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((
                                    _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<Employment>k__BackingField'
                                    ]
                                ) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, 
                                    _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<Employment>k__BackingField'
                                    ]
                                ]
              ]),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                id: "hcfa-patient-auto",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((
                                    _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<AutoAccident>k__BackingField'
                                    ]
                                ) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, 
                                    _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<AutoAccident>k__BackingField'
                                    ]
                                ]
              ]),
              _hoisted_8
            ]),
            (
                                _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<AutoAccident>k__BackingField'
                                ]
                            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      name: "hcfa-auto-accident-state",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                                '<AutoAccidentState>k__BackingField'
                                            ]
                                        ) = $event))
                    }, [
                      _hoisted_12,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.addressStateCode, (status, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: status.value
                        }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_13))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                                '<AutoAccidentState>k__BackingField'
                                            ]
                                        ]
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                id: "hcfa-patient-other",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
                                    _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<OtherAccident>k__BackingField'
                                    ]
                                ) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, 
                                    _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                        '<OtherAccident>k__BackingField'
                                    ]
                                ]
              ]),
              _hoisted_15
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              id: "Referral_claim_code",
              name: "referral-claim-code",
              class: "form-control",
              maxlength: "30",
              placeholder: "Enter Code",
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((
                                _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<ClaimCodes>k__BackingField'
                                ]
                            ) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, 
                                _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<ClaimCodes>k__BackingField'
                                ]
                            ]
            ])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("input", {
                    name: "patient-unable-from",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: 
                                        _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<UnableToWorkFrom>k__BackingField'
                                        ]
                                    ,
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_23),
                  _hoisted_24
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("input", {
                    name: "patient-unable-to",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: 
                                        _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<UnableToWorkTo>k__BackingField'
                                        ]
                                    ,
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_28),
                  _hoisted_29
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("input", {
                    name: "hospitalization-start-date",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: 
                                        _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<HospitalizationBegin>k__BackingField'
                                        ]
                                    ,
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_34),
                  _hoisted_35
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("input", {
                    name: "hospitalization-end-date",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: 
                                        _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                            '<HospitalizationEnd>k__BackingField'
                                        ]
                                    ,
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_39),
                  _hoisted_40
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: "hcfa-emergency-treatment",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
                                _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<IsEmergencyIndicatorRequired>k__BackingField'
                                ]
                            ) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, 
                                _ctx.referral.Insurance.AdditionalBillingInfo.HCFAAdditionalBillingInfo[
                                    '<IsEmergencyIndicatorRequired>k__BackingField'
                                ]
                            ]
            ]),
            _hoisted_42
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}